export const Sort = (data = [], field) => {
	return data?.sort((a, b) => a?.[field].localeCompare(b?.[field]));
};
